import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
    if (s > $(".section1 .num").offset().top - $(".section1").offset().top && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };

$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s > $(".section1 .num").offset().top - $(".section1").offset().top && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})
 
var leftSwiper = new Swiper('.left-swiper', {
    slidesPerView: 1,
    loop: true,
    allowTouchMove: false,
    speed: 800
});

var rightSwiper = new Swiper('.right-swiper', {
    slidesPerView: 2.28933,
    spaceBetween: 18,
    loop: true,
    allowTouchMove: false,
    initialSlide:1,
    speed: 800
});

$('.next').on('click', function () {

    leftSwiper.slideNext();
    rightSwiper.slideNext();

});

$('.prev').on('click', function () {

    leftSwiper.slidePrev();
    rightSwiper.slidePrev();

});


//内容等高
var p1_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section3 ul li .content').each(function() { //遍历相同样式名的元素
    var p1 = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    p1_max = p1 > p1_max ? p1 : p1_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section3 ul li .content').height(p1_max); //给每一个元素设置相同的高度
	

$(".map ul li .drop").hover(function() {
    $(this).parent().find(".text").css("display","flex");
    $(this).css("opacity",'1')
    $(this).parent().css("z-index","3");
},function() {
    $(".map ul li .text").hide();
    $(".map ul li .drop").css("opacity",'.7');
    $(".map ul li").css("z-index","2");
})